export const PAGE_SIZES = [1, 5, 10, 25, 50, 100]
export const INITIAL_PAGE_SIZE = 10

const tables = {
    accounts: {
        visibleKeys: ['_id', 'name', 'apiKey', 'created', 'role', 'confirmed'],
        keyTypes: {
            name: 'text',
            apiKey: 'text',
            _id: 'text',
            created: 'datetime',
            role: 'text',
            confirmed: 'boolean',
        },
        sortableKeys: ['_id', 'name', 'role', 'created'],
        editableKeys: ['name'],
        requiredKeys: ['name'],
    },
    users: {
        visibleKeys: ['_id', 'name', 'email', 'created', 'role'],
        keyTypes: {
            _id: 'text',
            name: 'text',
            email: 'email',
            created: 'datetime',
            role: 'text',
        },
    },
    invites: {
        visibleKeys: ['_id', 'name', 'email', 'created', 'role'],
        keyTypes: {
            _id: 'text',
            name: 'text',
            email: 'email',
            created: 'datetime',
            role: 'text',
        },
    },
    requests: {
        visibleKeys: ['name', 'approvalDate'],
        keyTypes: {
            _id: 'text',
            name: 'text',
            approvalDate: 'text',
        },
    },
    clientRequests: {
        visibleKeys: ['RequestCreat', 'RequestEnded', 'Status', 'PdfUrl'],
        keyTypes: {
            RequestCreat: 'date',
            RequestEnded: 'date',
            Status: 'historyRequestStatus',
            PdfUrl: 'report',
        },
        sortableKeys: [],
    },
    clients: {
        visibleKeys: [
            'name',
            'ClientPhone',
            'ClientEmail',
            'GenderKod',
            'RequestCreat',
            'RequestEnded',
            'Priority',
            'Status',
            'PdfUrl',
        ],
        visibleKeysMobile: ['name', 'Status'], //, 'PdfUrl'],
        keyTypes: {
            name: 'clientName',
            ClientPhone: 'removeClientPrefix',
            ClientEmail: 'text',
            GenderKod: 'gender',
            FamilyStatus: 'familyStatus',
            RequestCreat: 'date',
            RequestEnded: 'date',
            Status: 'requestStatus',
            PdfUrl: 'report',
            Priority: 'priority',
        },
        searchableKeys: [
            'ClientFirstName',
            'ClientLastName',
            'ClientPhone',
            'ClientId',
        ],
    },
}

export default tables
